/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import { Col, Row } from "reactstrap";
import { Btn, H6, Image } from "../../../AbstractElements";
import { Href, InStock, MoveToCarts, Price } from "../../../Constant";
import { useAppDispatch, useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { addToCartData } from "../../../Redux-Toolkit/Reducers/CartSlice";
import { setProductItem } from "../../../Redux-Toolkit/Reducers/ProductSlice";
import { dynamicImage } from "../../../Service/DynamicImage";
import { ProductItemInterface } from "../../../Type/EcommerceType";
import { ProductsApi } from "../../../api";
import { toast } from "react-toastify";

export const WishlistData = () => {
  const { productItem, symbol } = useAppSelector((state) => state.product);
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();

  const fetchProducts = async () => {
    try {
      await axios.get(ProductsApi).then((resp) => {
        dispatch(setProductItem(resp.data));
      });
    } catch (error) {
      toast.error("error"+ error);
    }
  };

  useEffect(() => { fetchProducts() }, []);


  const MoveToCart = (item:ProductItemInterface, quantity:number) => {
    dispatch(addToCartData({item, quantity}));
    Navigate(`${process.env.PUBLIC_URL}/ecommerce/cart`);
  };

  return (
    <Row className="g-sm-4 g-3">
      {productItem.map((item, index) => (
        <Col xl="4" md="6" key={index}>
          <div className="prooduct-details-box">
            <div className="d-flex">
              <Image className="align-self-center img-fluid img-60" src={dynamicImage('ecommerce/01.jpg')} alt="#" />
              <div className="flex-grow-1 ms-3">
                <div className="product-name">
                  <H6><a href={Href}>{item?.name}</a></H6>
                </div>
                <Rating initialValue={item.rating} size={17} />
                <div className="price d-flex">
                  <div className="text-muted me-2">{Price}</div> : {item.price}{symbol}</div>
                <div className="avaiabilty">
                  <div className="text-success">{InStock}</div>
                </div>
                <Btn color="primary" size="xs" onClick={() => MoveToCart(item, 1)}>{MoveToCarts}</Btn>
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};
